import React from "react";
import TriggersHistoricTable from "./TriggersHistoricTable";

function TriggersHistoric(props) {

    const {alert_triggers} = props

    if (alert_triggers.length === 0){
        return (
            <div style={{display: "flex", height: "60px"}}>
                <div className={["labelText", "normalMediumSize"].join(" ")} style={{margin:"auto"}}>
                Sem Histórico de Transação
                </div>
            </div>
        )
    }
    else {
        return (
                <div>
                    <div>
                        <TriggersHistoricTable
                            alert_triggers={alert_triggers}
                        />                    
                    </div>
                </div>
        );
    }
  }
  
  export default TriggersHistoric;